import { defineAsyncComponent } from 'vue'

// Vue Router 4 wants the raw `() => import(...)` factory and handles the
// async resolution itself. Wrapping in defineAsyncComponent breaks the
// router-view's navigation lifecycle — the URL changes but the child
// component never swaps out (tabs look like they do nothing). Use these
// helpers in router/index.js. For dynamic `<component :is="...">` slots
// (drawer/overlay containers), use loadView/loadComponent below since
// those targets do require a real component definition.
const routeView = (fileObj) => {
	if (fileObj.hasOwnProperty('path') && fileObj.path !== null && fileObj.path !== '' && fileObj.hasOwnProperty('file')) {
		return () => import(/* webpackChunkName: "view-[request]" */ `@/views/${fileObj.path}/${fileObj.file}.vue`)
	} else if (fileObj.hasOwnProperty('file')) {
		return () => import(/* webpackChunkName: "view-[request]" */ `@/views/${fileObj.file}.vue`)
	}
	throw "routeView requires an object with a file string, and optionally a path string"
}

const routeComponent = (fileObj) => {
	if (fileObj.hasOwnProperty('path') && fileObj.path !== null && fileObj.path !== ''  && fileObj.hasOwnProperty('file')) {
		return () => import(/* webpackChunkName: "component-[request]" */ `@/components/${fileObj.path}/${fileObj.file}.vue`)
	} else if (fileObj.hasOwnProperty('file')) {
		return () => import(/* webpackChunkName: "component-[request]" */ `@/components/${fileObj.file}.vue`)
	}
	throw "routeComponent requires an object with a file string, and optionally a path string"
}

const loadView = (fileObj) => {
	if (fileObj.hasOwnProperty('path') && fileObj.path !== null && fileObj.path !== '' && fileObj.hasOwnProperty('file')) {
		return defineAsyncComponent(() => import(/* webpackChunkName: "view-[request]" */ `@/views/${fileObj.path}/${fileObj.file}.vue`))
	} else if (fileObj.hasOwnProperty('file')) {
		return defineAsyncComponent(() => import(/* webpackChunkName: "view-[request]" */ `@/views/${fileObj.file}.vue`))
	}
	throw "loadView requires an object with a file string, and optionally a path string"
}

const loadComponent = (fileObj) => {
	if (fileObj.hasOwnProperty('path') && fileObj.path !== null && fileObj.path !== ''  && fileObj.hasOwnProperty('file')) {
		return defineAsyncComponent(() => import(/* webpackChunkName: "component-[request]" */ `@/components/${fileObj.path}/${fileObj.file}.vue`))
	} else if (fileObj.hasOwnProperty('file')) {
		return defineAsyncComponent(() => import(/* webpackChunkName: "component-[request]" */ `@/components/${fileObj.file}.vue`))
	}
	throw "loadComponent requires an object with a file string, and optionally a path string"
}

export {
	loadView,
	loadComponent,
	routeView,
	routeComponent
}
